"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosUtils = void 0;
/**
 * Axios utilities
 */
var AxiosUtils;
(function (AxiosUtils) {
    function isAxiosError(e) {
        return (typeof e === "object"
            && e !== null
            && "isAxiosError" in e);
    }
    AxiosUtils.isAxiosError = isAxiosError;
})(AxiosUtils = exports.AxiosUtils || (exports.AxiosUtils = {}));
//# sourceMappingURL=axios.js.map